















































































































































































  import { PullRefresh,Overlay,Toast,Popup,List } from "vant";
  import {
    sendSock,
    getSock,
    closeWebSocket,
    openWebSocket
  } from '@/utils/ws'
  import { myTransactionSocket } from "@/views/h5-page/mixins/myTransactionSocket";
  export default {
    components: {
      [Overlay.name]: Overlay,
      [PullRefresh.name]: PullRefresh,
      [Popup.name]: Popup,
      [List.name]: List,
    },
    mixins: [myTransactionSocket],
    props:{
        queryParem:{
            type:Object,
            default:{}
        },
        activeTab:{
            type:Number,
            default:0
        }
    },
    data() {
      return {
        refreshing: false,

        loading: false,
        finished: false,
        list:[],

        current_page:0,
        tableData:{
            fields:[],
            list:[]
        },
        totalNum:0,

        isScroll:false,
        tableMouseObj: {
          isDragging: false,
          startX: 0,
          startScrollLeft: 0
        }
      };
    },
    computed:{
        fieldData(){
            return (this as any).tableData.fields.map(item =>{
                return item.keyId
            })
        }
    },
    filters:{
        tabelRow(val){
            if(val){

            }else{
                return '-'
            }
        }
    },
    watch:{
        queryParem:{
            handler(val){
                setTimeout(()=>{
                    if((this as any).activeTab === 3){
                        (this as any).refreshing = true;
                        (this as any).onRefresh();
                    }
                },0)
            },
            deep:true
        },
        activeTab:{
            handler(val){
              clearTimeout((this as any).timer);
                if(val === 3){
                    (this as any).refreshing = true;
                    (this as any).onRefresh();
                }
            },
            deep:true
        }
    },
    created(){
      const _this = this as any;
      _this.onLoad();
    },
    mounted() {
      const _window = (window as any);
      const _this = (this as any);
      _this.visibilityFn = (e) => {
        if(e.target.visibilityState == 'hidden'){
          clearTimeout(_this.timer);
        }else{
          if ((this as any).activeTab === 3) {
            clearTimeout(_this.timer);
            _this.onRefresh();
          }
        }
      };
      _window.addEventListener('visibilitychange', _this.visibilityFn);
    },
    methods: {
        tableScroll(e){
            if((this as any).$refs['tableList'].scrollLeft == 0){
                //滚动至最左边触发
                (this as any).isScroll = false;
            }else{
                (this as any).isScroll = true;
            }
        },
        // socket变动
		getSocketList(){
            // 
			let symbol = '';
			(this as any).tableData.list.forEach(item =>{
				symbol += item.symbol + ','
			});
			let struct:any = {
			  MsgType: 'SubTicks',
			  MsgBody: {
			    symbol: symbol
			  }
			};
			sendSock(struct);
			getSock((this as any).getMsg);
		},

		getMsg(msg){
			if((this as any).tableData.list.length !== 0){
                // 
				(this as any).tableData.list.forEach(item =>{
                    let curSymbol = item.curItems.find(val => val.symbol === msg.symbol);
					if(curSymbol){
						if(!msg.last_price && !msg.pre_closing_price){
							item.quote_price = msg.pre_settle_price
						}else if(!msg.last_price && !msg.pre_settle_price){
							item.quote_price = msg.pre_closing_price
						}else if(!msg.pre_closing_price && !msg.pre_settle_price){
							item.quote_price = msg.last_price
						}else{
							item.quote_price = msg.last_price
						}
                        if((this as any).queryParem.type === 1){
                            item.profitLoss = 0;
                            item.curItems.forEach(v => {
                                // let curItem = res.data.pos_infos && res.data.pos_infos.find(val => val.account_no === item.account_no);
                                let symbol = msg.symbol;
                                if(symbol === v.symbol){
                                    let curItem = v;
                                    // 仓位 : match_side == 66 ?  position_qty : -position_qty
                                    let position = curItem.match_side == 66 ?curItem.position_qty : -curItem.position_qty;
                                    //当前价 - 加权成交价）* 仓位 * 当前汇率 * 合约乘数
                                    // 
                                    item.profitLoss = item.profitLoss + Number(((item.quote_price - curItem.position_price) * position * item.rateNum * item.contract_size).toFixed(2));
                                };
                            });
                        }else if((this as any).queryParem.type === 2){
                            item.profitLoss = 0;
                            item.curItems.forEach(v => {
                                // let curItem = res.data.pos_infos && res.data.pos_infos.find(val => val.account_no === v.account_no);
                                // let symbol = result[0].data.future_ticks.find(val => val.symbol === curItem.symbol);
                                let symbol = msg.symbol;
                                if(symbol === v.symbol){
                                    let curItem = v;
                                    // （最新价 - 持仓价position_price）* 股数position_qty
                                    item.profitLoss = +(((item.quote_price - curItem.position_price) * curItem.position_qty).toFixed(2)) + item.profitLoss;

                                }
                            });
                        }
					}
				})
			}
		},
        async onLoad() {
          const _this = this as any;

                // (this as any).current_page++;
                (this as any).loading = true;
                await _this.getListNew();
                (this as any).loading = false;
        },
        async onRefresh() {
          // 在触发@refresh="onRefresh"时，_this.refreshing = true;

          const _this = (this as any);
          _this.restDataForRefreshing();

          await _this.onLoad();
          _this.refreshing = false;
        },
        mySocketOnMsg(msg){
          const _this = (this as any);
          if (_this.activeTab == 3) {
            _this.onRefresh();
          }
        },

      async getListNew() {
        await (this as any).getList();
        clearTimeout((this as any).timer);
        if(localStorage.getItem('token')){
          (this as any).timer = setTimeout(() => {
            (this as any).getListNew();
          }, 10000);
        }
      },

        async getList(){
            if(!(this as any).queryParem.account){
                return
            }
          (this as any).socketTransaction((this as any).queryParem.account,()=>{
            (this as any).mySocketOnMsg();
          });
            let listParem:any = {
                page:0,
                size:1000,
                account_nos:(this as any).queryParem.account || ''
            };
          let tableDataList: any = [];
          // (this as any).tableData.fields = [];
            await (this as any).$apis
            .querybatchpos(listParem,{'X-channel-id': (this as any).queryParem.type})
            .then(async(res) => {
                // Toast('刷新成功');
                let q = res.data.pos_infos.map(item => {
                    return item.symbol
                }).join(',');
                let queryParem:any = {
                    page_size:1000,
                    current_page:(this as any).current_page,
                    account_no:(this as any).queryParem.account
                };

                if(q){
                    let qute = (this as any).$apis
                    .future_ticksnapshot({symbol:q});
                    let rate = (this as any).$apis
                    .getRate({symbol:q});
                    let contractInfote = (this as any).$apis
                    .getContractInfo({symbol:q,isExpired:2});
                    let getQryFund = (this as any).$apis
                    .querygroupfund(queryParem,{'X-channel-id': (this as any).queryParem.type});
                    if((this as any).queryParem.type === 1){
                        Promise.all([qute, rate,contractInfote,getQryFund]).then((result) => {
                            (this as any).totalNum = result[3].data.total;
                            (this as any).tableData.fields = result[3].data.fields;
                            // 
                            result[3].data.fund_infos.forEach(item => {
                                let curItems = res.data.pos_infos && res.data.pos_infos.filter(val => val.account_no === item.account_no);
                                // let curItem:any = {};
                                item.quote_price = null; //最新价
                                item.profitLoss = null;

                                item.rateNum = null;  //当前汇率
                                item.contract_size = null;  //合约乘数
                                item.curItems = curItems; //账户组
                                item.symbol = null;
                                curItems.forEach(v => {
                                    // let curItem = res.data.pos_infos && res.data.pos_infos.find(val => val.symbol === v.symbol);
                                    let symbol = result[0].data.future_ticks.find(val => val.symbol === v.symbol);

                                    if(symbol){
                                        let curItem = v;
                                        item.symbol = item.symbol?item.symbol+','+curItem.symbol:curItem.symbol;
                                        let contract_info = result[2].data.contract_info.find(val => val.symbol === curItem.symbol);
                                        // let fund = result[3].data.fund_infos.find(val => val.account_no === item.account_no);
                                        let curRate = result[1].data.currency_rate.find(val => {
                                            if(val.to === item.currency_no && val.from === contract_info.currency_no){
                                                return val;
                                            }
                                        });
                                        // 当前汇率取值逻辑如下：
                                        // 1、当持仓方向为买入(matchSize:83)，此时汇率取买(汇率的buy字段)。
                                        // 2、当持仓方向为卖出(matchSize:66)，此时汇率取卖(汇率的sel字段)。
                                        let rateNum:any = 1;
                                        if(curRate){
                                          rateNum = curItem.match_side == 66 ? curRate.sell : curRate.buy;
                                        }
                                        // 仓位 : match_side == 66 ?  position_qty : -position_qty
                                        let position = curItem.match_side == 66 ?curItem.position_qty : -curItem.position_qty;

                                        item.quote_price = symbol.last_price || symbol.pre_closing_price || symbol.pre_settle_price;
                                        //当前价 - 加权成交价）* 仓位 * 当前汇率 * 合约乘数
                                        // 
                                        // 
                                        item.profitLoss = item.profitLoss + Number(((item.quote_price - curItem.position_price) * position * rateNum * contract_info.contract_size).toFixed(2));

                                        item.rateNum = rateNum;
                                        item.contract_size = contract_info.contract_size;
                                    }else{
                                        let curItem = v;
                                        if(!curItem.calculate_price){
                                            return
                                        }
                                        item.symbol = item.symbol?item.symbol+','+curItem.symbol:curItem.symbol;
                                        item.quote_price = curItem.calculate_price;
                                        let contract_info = result[2].data.contract_info.find(val => val.symbol === curItem.symbol);
                                        let curRate = result[1].data.currency_rate.find(val => {
                                            if(val.to === item.currency_no && val.from === contract_info.currency_no){
                                                return val;
                                            }
                                        });
                                        // 当前汇率取值逻辑如下：
                                        // 1、当持仓方向为买入(matchSize:83)，此时汇率取买(汇率的buy字段)。
                                        // 2、当持仓方向为卖出(matchSize:66)，此时汇率取卖(汇率的sel字段)。
                                        let rateNum:any = 1;
                                        if(curRate){
                                          rateNum = curItem.match_side == 66 ? curRate.sell : curRate.buy;
                                        }
                                        // 仓位 : match_side == 66 ?  position_qty : -position_qty
                                        let position = curItem.match_side == 66 ?curItem.position_qty : -curItem.position_qty;

                                        //当前价 - 加权成交价）* 仓位 * 当前汇率 * 合约乘数
                                        item.profitLoss = item.profitLoss + Number(((item.quote_price - curItem.position_price) * position * rateNum * contract_info.contract_size).toFixed(2));

                                        item.rateNum = rateNum;
                                        item.contract_size = contract_info.contract_size;
                                    }
                                });
                              tableDataList.push(item);
                            });
                          (this as any).tableData.list = tableDataList;
                            
                            
                            // (this as any).getSocketList();
                            if ((this as any).tableData.list.length >= (this as any).totalNum) {
                                (this as any).finished = true;
                            }
                        })
                    }else if((this as any).queryParem.type === 2){
                        // 持仓盈亏（股票）=  （最新价 - 持仓价position_price）* 股数position_qty
                        Promise.all([qute,contractInfote,getQryFund]).then((result) => {
                            
                            (this as any).totalNum = result[2].data.total;
                            (this as any).tableData.fields = result[2].data.fields;
                            result[2].data.fund_infos.forEach(item => {
                                let curItems = res.data.pos_infos && res.data.pos_infos.filter(val => val.account_no === item.account_no);
                                item.quote_price = null;
                                item.profitLoss = null;

                                item.rateNum = null;  //当前汇率
                                item.contract_size = null;  //合约乘数
                                item.curItems = curItems; //账户组
                                item.symbol = null;
                                curItems.forEach(v => {
                                    // let curItem = res.data.pos_infos && res.data.pos_infos.find(val => val.account_no === v.account_no);
                                    let symbol = result[0].data.future_ticks.find(val => val.symbol === v.symbol);

                                    if(symbol){
                                        let curItem = v;
                                        item.symbol = item.symbol?item.symbol+','+curItem.symbol:curItem.symbol;
                                        let contract_info = result[1].data.contract_info.find(val => val.symbol === curItem.symbol);
                                        item.quote_price = symbol.last_price || symbol.pre_closing_price || symbol.pre_settle_price;
                                        // （最新价 - 持仓价position_price）* 股数position_qty
                                        item.profitLoss = +(((item.quote_price - curItem.position_price) * curItem.position_qty).toFixed(2)) + item.profitLoss;

                                        item.contract_size = contract_info.contract_size;
                                    }else{
                                        let curItem = v;
                                        if(!curItem.calculate_price){
                                            return
                                        }
                                        item.quote_price = curItem.calculate_price
                                        item.symbol = item.symbol?item.symbol+','+curItem.symbol:curItem.symbol;
                                        let contract_info = result[1].data.contract_info.find(val => val.symbol === curItem.symbol);
                                        // （最新价 - 持仓价position_price）* 股数position_qty
                                        item.profitLoss = +(((item.quote_price - curItem.position_price) * curItem.position_qty).toFixed(2)) + item.profitLoss;

                                        item.contract_size = contract_info.contract_size;
                                    }
                                });

                              tableDataList.push(item);
                            });
                          (this as any).tableData.list = tableDataList;
                            // 
                            // 
                            // 
                            // (this as any).getSocketList();
                            if ((this as any).tableData.list.length >= (this as any).totalNum) {
                                (this as any).finished = true;
                            }
                        })
                    }
                }else{
                    let queryParem:any = {
                        page_size:10,
                        current_page:(this as any).current_page,
                        account_no:(this as any).queryParem.account
                    };

                    (this as any).$apis
                    .querygroupfund(queryParem,{'X-channel-id': (this as any).queryParem.type})
                    .then(res => {
                        (this as any).totalNum = res.data.total;
                        (this as any).tableData.fields = res.data.fields;
                        res.data.fund_infos.forEach(item => {

                          tableDataList.push(item);
                        });
                      (this as any).tableData.list = tableDataList;
                        // 
                        // 
                        if (!res.data.fund_infos.length || ((this as any).tableData.list.length >= (this as any).totalNum)) {
                            (this as any).finished = true;
                        }
                    })
                    .catch(e => {
                        
                    });
                }
                // 
                // 
                // (this as any).getSocketList();
                // if ((this as any).tableData.list.length >= (this as any).totalNum) {
                //     (this as any).finished = true;
                // }
            })
            .catch(e => {
                let queryParem:any = {
                    page_size:10,
                    current_page:(this as any).current_page,
                    account_no:(this as any).queryParem.account
                };

                (this as any).$apis
                .querygroupfund(queryParem,{'X-channel-id': (this as any).queryParem.type})
                .then(res => {
                    (this as any).totalNum = res.data.total;
                    (this as any).tableData.fields = res.data.fields;
                    res.data.fund_infos.forEach(item => {
                        (this as any).tableData.list.push(item)
                    });
                    // 
                    // 
                    if (!res.data.fund_infos.length || ((this as any).tableData.list.length >= (this as any).totalNum)) {
                        (this as any).finished = true;
                    }
                })
                .catch(e => {
                    
                });
                // 
            });
        },
      /**
       * @Description PC端兼容滑动 tableMouseDown、tableMouseMove、tableMouseUp、allTableMouseMove、allTableMouseUp
       * @date 2024/1/8
       * @param
       * @return {void}
       */
      tableMouseDown(e,mouseObj,refStr){
        let _this = (this as any);
        mouseObj.isDragging = true;
        mouseObj.startX = e.clientX;
        mouseObj.startScrollLeft = _this.$refs[refStr].scrollLeft;
      },
      tableMouseMove(e,mouseObj,refStr){
        let _this = (this as any);
        if (mouseObj.isDragging) {
          const deltaX = e.clientX - mouseObj.startX;
          _this.$refs[refStr].scrollLeft = mouseObj.startScrollLeft - deltaX;
        }
      },
      tableMouseUp(e,mouseObj){
        mouseObj.isDragging = false;
      },
      allTableMouseMove(e){
        let _this = (this as any);
        _this.tableMouseMove(e,_this.tableMouseObj,'tableList');
      },
      allTableMouseUp(e){
        let _this = (this as any);
        _this.tableMouseUp(e,_this.tableMouseObj);
      },
      allTableMouseLeave(e){
        let _this = (this as any);
        _this.tableMouseUp(e,_this.tableMouseObj);
      },
      /**
       * @Description 重新刷新前的准备动作
       * @date 2024/1/16
       * @return {void}
       */
      restDataForRefreshing() {
        const _this = (this as any);

        // van-list相关数据
        _this.finished = false;

        // 列表相关数据
        _this.tableData.list = [];

        // 分页请求相关数据
        _this.current_page = 0;
        _this.totalNum = 0;
      }
    },
    destroyed() {
      clearTimeout((this as any).timer);
      (window as any).removeEventListener('visibilitychange', (this as any).visibilityFn);
    }
  };
  